import PropTypes from 'prop-types';
import { Steps } from 'primereact';
import React, { useState } from 'react';
import ActionButton from './ActionButton';
import { t } from 'i18next';

export const StepperComponent = ({
    model,
    validation,
    readOnly,
    outsideClassName,
    stepClassName,
    components,
    buttonsAlignRight,
    renderRightExtras,
}) => {
    const [activeStep, setActivestep] = useState(0);
    const component = () =>{
        const component = components[activeStep];
        return component;
    }
    const isLastStep = () => {
        return model.length === activeStep + 1;
    }
    const isFirstStep = () => {
        return 0 === activeStep;
    }
    return (
        <div className={outsideClassName}>
            <Steps model={model} activeIndex={activeStep} readOnly={readOnly} className={stepClassName}/>
            {component()}
            {buttonsAlignRight ? (
                <div className='row mb-3'>
                    <div className='col-12' style={{textAlign: 'right'}}>
                        {!isFirstStep() && (
                            <span style={{marginLeft: 8}}>
                                <ActionButton id={'prev-step'} reverse handleClick={(e)=>{setActivestep(activeStep - 1)}} label={t('global.prev')}></ActionButton>
                            </span>
                        )}
                        {!isLastStep() && (
                            <span style={{marginLeft: 8}}>
                                <ActionButton id={'next-step'} reverse handleClick={(e)=>{ 
                                    if(validation){
                                        validation(()=>{setActivestep(activeStep + 1)});
                                        return;
                                    }
                                    setActivestep(activeStep + 1)
                                    }} label={t('global.next')} />
                            </span>
                        )}
                        {typeof renderRightExtras === 'function' ? (
                            <span style={{marginLeft: 8}}>{renderRightExtras(activeStep, isLastStep())}</span>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div className='row mb-3'>
                    <div className='col-6'>{!isFirstStep() && <ActionButton id={'prev-step'} reverse handleClick={(e)=>{setActivestep(activeStep - 1)}} label={t('global.prev')}></ActionButton>}</div>
                    <div className='col-6'>{!isLastStep() && <ActionButton id={'next-step'} reverse style={{float: 'right'}} handleClick={(e)=>{ 
                        if(validation){
                            validation(()=>{setActivestep(activeStep + 1)});
                            return;
                        }
                        setActivestep(activeStep + 1)
                        }} label={t('global.next')} />}</div>
                </div>
            )}
        </div>
    );
};

StepperComponent.defaultProps = {
    model: [],
    validation: undefined,
    outsideClassName: "",
    stepClassName: "",
    readOnly: true,
    components: [],
    buttonsAlignRight: false,
    renderRightExtras: undefined,
};

StepperComponent.propTypes = {
    outsideClassName: PropTypes.string,
    stepClassName: PropTypes.string,
    readOnly: PropTypes.bool,
    validation: PropTypes.func,
    model: PropTypes.array.isRequired,
    components: PropTypes.array.isRequired,
    buttonsAlignRight: PropTypes.bool,
    renderRightExtras: PropTypes.func,
};

export default StepperComponent;
